import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useQuantityTypeCategories } from 'src/hooks'
import { IQuantityTypeCategoryBaseWithId } from 'src/types'

export const QuantityTypeCategoriesInput = () => {
  const [t] = useTranslation()
  const { data: items, isLoading } = useQuantityTypeCategories()
  const { values, handleChange } = useFormikContext<{
    category: IQuantityTypeCategoryBaseWithId | undefined
  }>()

  const handleCategoryChange = (event: any, value: null | IQuantityTypeCategoryBaseWithId) => {
    handleChange({
      target: {
        name: 'category',
        value,
      },
    })
  }

  return (
    <Autocomplete
      disablePortal
      autoHighlight
      disableClearable
      defaultValue={values.category}
      options={items?.data || []}
      value={values.category}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => option?.name}
      renderOption={(props, option) => <li {...props}>{option.name}</li>}
      fullWidth
      onChange={handleCategoryChange}
      loading={isLoading}
      loadingText={t('loading-text-notification.v')}
      renderInput={(props) => (
        <TextField
          {...props}
          autoComplete="off"
          variant="standard"
          style={{ height: '100%' }}
          size="small"
          label={t('category-input-label.v') + '*'}
          id="category"
          name="category"
          type="text"
        />
      )}
    />
  )
}
